import React from 'react';


const NotFound = () => (

<>
<h1 className="x-large text-primary">
  <i className="fas fa-exclamation-triangle"> Page Not Found
  </i>
</h1>
<p className="large">Sorry, This page does not exists.</p>
</>

)


export default NotFound